"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLatestRestorePointValue = void 0;
const constants_1 = require("../../../../../constants");
const ConfigurationBackupModel_1 = require("../../../ConfigurationBackupModel");
const getLatestRestorePointValue = ({ status, texts }) => {
    switch (status) {
        case ConfigurationBackupModel_1.CONFIGURATION_BACKUP_STATUS.pending:
            return texts.pending;
        case ConfigurationBackupModel_1.CONFIGURATION_BACKUP_STATUS.failed:
            return texts.failed;
        case ConfigurationBackupModel_1.CONFIGURATION_BACKUP_STATUS.success:
            return texts.success;
        case ConfigurationBackupModel_1.CONFIGURATION_BACKUP_STATUS.none:
        default:
            return constants_1.EMPTY_TEXT.dash;
    }
};
exports.getLatestRestorePointValue = getLatestRestorePointValue;
//# sourceMappingURL=getLatestRestorePointValue.js.map